import React, { Component } from "react";
import { add, format } from "date-fns";
import DesktopCalender from "../../../calendar/activityCalendar/theme4/DesktopCalender";
import autoSuggest from "../../../../lib/autoSuggest";
import cf from "../../../../lib/utils/common";
import MobileCalender from "../../../calendar/activityCalendar/theme4/MobileCalender";
import moment from "moment";
import B2BWidgets from "../../../b2bwidgets/index";
import PassengerCounter from "@/commonComponents/paxSelecttion/index";
import { offlineCreateEnquiry } from "../../../../../common/lib/enquiry";
import ModalPopupComponent from "../../../ModalPopupComponent/theme5/ModalPopupComponent";
import { getCity } from "../../../../../common/lib/myProfile";
import CountryDropdownComp from "../../../CountryDropdown/index";
import TripTypeSelector from "../../../../components/TripTypeSelector/theme4/index.js";

// static 5 cities
const popularCities = [
  {
    destination_id: "11663",
    search_text: "Mumbai",
    location_type: 1,
  },
  {
    destination_id: "11667",
    search_text: "New Delhi",
    location_type: 1,
  },
  {
    destination_id: "11634",
    search_text: "Chennai",
    location_type: 1,
  },
  {
    destination_id: "12633",
    search_text: "Dubai",
    location_type: 1,
  },
  {
    destination_id: "10516",
    search_text: "Paris",
    location_type: 1,
  },
];

export default class Theme4 extends Component {
  constructor(props) {
    super(props);
    this.searchBoxRef = React.createRef();
    this.advanceSearchWrapper = React.createRef();
    this.guestDetailWrapper = React.createRef();
    this.state = {
      activityName: this.props?.seoDestination
        ? this.props?.seoDestination
        : new URLSearchParams(window.location.search).has("location")
        ? new URLSearchParams(window.location.search).get("location").toString()
        : "",
      isAutoSuggestVisible: false,
      checkInOutValue: this.props.isSrp
        ? new URLSearchParams(window.location.search).has("checkin")
          ? cf.getDateWithFormat(
              new URLSearchParams(window.location.search)
                .get("checkin")
                .toString(),
              "DD MMM YY"
            )
          : moment().add(this.props?.seoDays, "days").format("DD MMM YY")
        : "",
      checkInValue: null,
      checkOutValue: null,
      isCalendarVisible: false,
      autoSuggestCountryData: [],
      autoSuggestCityData: popularCities,
      selectedAutoSuggestData: {
        search_text: this.props.isSrp
          ? new URLSearchParams(window.location.search).has("location")
            ? new URLSearchParams(window.location.search)
                .get("location")
                .toString()
            : ""
          : "",
        location_type: this.props.isSrp
          ? new URLSearchParams(window.location.search).has("search_type")
            ? new URLSearchParams(window.location.search).get("search_type")
            : ""
          : "",
        destination_id: this.props.isSrp
          ? new URLSearchParams(window.location.search).has("search_text")
            ? new URLSearchParams(window.location.search)
                .get("search_text")
                .toString()
            : ""
          : "",
      },
      isError: false,
      isDateError: false,
      lastArrowAction: "",
      selectedAutoSuggestIndex: -1,
      advSearch: false,
      isOneStar: false,
      isTwoStar: false,
      isThreeStar: false,
      isFourStar: false,
      isFiveStar: false,
      ratingSelected: [],
      guest_id: "",
      guestError: false,
      showCalendar: false,
      userProfileData: "",
      recentSearchData: [],
      destinationDropdown: false,
      travelers: { adults: 1, children: 0, infants: 0 },
      maxPaxAllowed: 7,
      onLoadPopup: false,
      enquiry_id: "",
      isLoading: false,
      countryList: [],
      pickuploc: "",
      selectedCountry: "",
      selectedCountryLocation: "",
      selectedHotelAddress: "",
      isErrloc: "",
      btnClicked: false,
      bookingTripId: parseInt(new URLSearchParams(window.location.search).get("bookingType"))||"",
    };
  }
  onClickAdvSearch = () => {
    if (!this.state.advSearch) {
      this.setState({ advSearch: true });
    } else {
      this.setState({ advSearch: false });
    }
  };
  componentDidMount() {
    // console.log("select====>", this.props.offlineType);
    let countryFlagList = [];
    getCity().then((res) => {
      if (res && res.data && res.data.length > 0) {
        console.log(res, "res");
        res.data.map((fact, index) => {
          countryFlagList.push({
            value: fact.city_name,
            isdCode: fact.city_name,
            countryCode: fact.city_name,
            // flag: fact.contry_flag,
            // countryFlag: fact.contry_flag,
            countryId: index,
            countryName: fact.city_contry[0].name || "",
          });
        });
        this.setState({ countryList: [...countryFlagList] });
      }
    });
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  //Add client
  adGuestId = (id) => {
    this.setState({ guest_id: id }, () => {
      if (this.state.guestError === true) {
        this.setState({ guestError: cf.isValueEmpty(id) ? true : false });
      }
      this.setState({ guest_id: id });
    });
  };
  rmGuestId = () => {
    this.setState({ guest_id: "" });
  };
  onChangeCheckInOutValue = (dateValue) => {
    console.log("date=value", dateValue);
    this.setState({
      checkInValue: cf.getDateWithFormat(
        // new Date(dateValue),
        dateValue,
        this?.props?.dateFormat
      ),
      checkOutValue: cf.getDateWithFormat(
        add(new Date(dateValue), { days: 8 }),
        this?.props?.dateFormat
      ),
      checkInOutValue: cf.getDateWithFormat(dateValue, "DD MMM YY"),
      isDateError: false,
      // isCalendarVisible: false
    });
  };

  onChanegeSetActivityName = (value) => {
    let recentSearchArray = [];
    this.setState({ activityName: value, isError: false, selectedAutoSuggestData: null });
    if (value === "") {
      this.setState({
        autoSuggestCityData: popularCities,
        // isAutoSuggestVisible: false,
        selectedAutoSuggestData: null,
      });
    } else {
      this.debouncedFetchData(value, (data) => {
        if (
          data &&
          data.data &&
          data.data.searchBycity &&
          typeof data.data.searchBycity === "object"
        ) {
          this.setState({
            autoSuggestCityData: [...data.data.searchBycity.result],
            isAutoSuggestVisible: true,
            recentSearchData: recentSearchArray,
          });
        } else if (data && data.data && data.data.status == false) {
          this.setState({
            autoSuggestCityData: [],
            isAutoSuggestVisible: true,
            recentSearchData: recentSearchArray,
          });
        }
      });
    }
  };

  debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  };

  debouncedFetchData = this.debounce((query, cb) => {
    this.fetchData(query, cb);
  }, 400);

  fetchData = async (query, callBackFunc) => {
    if (query != "") {
      const res = await autoSuggest({
        searchText: query,
        isSrp: this.props.isSrp,
      });
      callBackFunc(res);
    } else {
      callBackFunc(null);
    }
  };

  onClickSearchActivity = () => {
    console.log("search hit");
    if (
      !(
        this.state.selectedAutoSuggestData &&
        this.state.selectedAutoSuggestData.search_text
      )
    ) {
      this.setState({ isError: true });
    }
    if (this.state.checkInOutValue == "") {
      this.setState({ isDateError: true });
    }
    // if (this.props.isOffline === true && this.state.guest_id === "") {
    //   this.setState({ guestError: true });
    // } else {
    //   this.setState({ guestError: false });
    // }
    if (
      this.state.selectedAutoSuggestData &&
      this.state.selectedAutoSuggestData.search_text &&
      this.state.checkInOutValue
    ) {
      let urlQuery = {
        location: this.state.selectedAutoSuggestData.search_text,
        checkin: format(new Date(this.state.checkInOutValue), "yyyy-MM-dd"),
        checkout: cf.getDateWithFormat(
          add(new Date(this.state.checkInOutValue), { days: 1 }),
          "yyyy-MM-DD"
        ),
        from: 1,
        to: 30,
        search_type: this.state.selectedAutoSuggestData.location_type,
        search_text: this.state.selectedAutoSuggestData.destination_id,
        currency: "INR",
        rating: [...new Set(this.state.ratingSelected)].join(","),
        guestId: this.state.guest_id,
        isModifySearch: this.props.isModifySearch || false,
        bookingType: this.state.bookingTripId,
      };
      if (this.props.isOffline === true) {
        // if (this.state.guest_id !== "") {
          const searchParams = new URLSearchParams(urlQuery);
          const queryString = searchParams.toString();
          window.location = "/offlinesearch/activity?" + queryString;
        // }
        // window.open(`${window.location.origin}` + "/offlinesearch/activity" , "_self");
        // cf.redirectTo("/offlinesearch/activity", urlQuery)
      } else {
        cf.redirectTo("/activity/search", urlQuery);
      }
    } else {
      console.log("please select guest id");
    }
  };
  onClickSetActivityName = (element) => {
    this.setState({
      activityName: element.search_text,
      selectedAutoSuggestData: element,
      isError: false,
    });
  };
  onInputFocus = (fieldName) => {
    if (fieldName == "autocomplete") {
      if (this.state.isAutoSuggestVisible === false) {
        this.setState({ isAutoSuggestVisible: true, isCalendarVisible: false });
      }
    } else if (fieldName == "search") {
      this.setState({ isAutoSuggestVisible: false, isCalendarVisible: false });
    }
  };

  keyPress = (action) => {
    switch (action) {
      case "ArrowDown":
        console.log("keyPress fn down called ", action);
        let children = document.getElementById(
          "ACTIVITY-AUTO-SUGGEST-DATA-LIST"
        ).children;

        let selectIndex = 0;
        selectIndex =
          this.state.selectedAutoSuggestIndex == children.length - 1
            ? 0
            : this.state.selectedAutoSuggestIndex + 1;
        console.log("children of auto-suggest", children);
        for (let index = 0; index < children.length; index++) {
          let childElement = children[index];
          let id = childElement.id;
          if (id != null && id != "") {
            childElement.style.backgroundColor =
              selectIndex === index ? "#ccc" : "#fff";
          }
        }
        this.setState({
          selectedAutoSuggestIndex: selectIndex,
          lastArrowAction: "ArrowDown",
        });
        break;
      case "ArrowUp":
        console.log("keyPress fn up called ", action);
        let childrens = document.getElementById(
          "ACTIVITY-AUTO-SUGGEST-DATA-LIST"
        ).children;
        let selectIndexUp = 0;
        selectIndexUp =
          this.state.selectedAutoSuggestIndex == childrens.length - 1
            ? 0
            : this.state.selectedAutoSuggestIndex == -1
            ? 0
            : this.state.selectedAutoSuggestIndex - 1;
        console.log("children of auto-suggest", childrens);
        for (let index = 0; index < childrens.length; index++) {
          let childElement = childrens[index];
          let id = childElement.id;
          if (id != null && id != "") {
            childElement.style.backgroundColor =
              selectIndexUp === index ? "#ccc" : "#fff";
          }
        }
        // this.setState((prevState) => ({
        //   selectedAutoSuggestIndex:
        //     prevState.selectedAutoSuggestIndex > 0
        //       ? prevState.lastArrowAction=="ArrowDown"?prevState.selectedAutoSuggestIndex - 1:prevState.selectedAutoSuggestIndex
        //       : prevState.selectedAutoSuggestIndex+1,
        //   lastArrowAction: "ArrowUp",
        // }));
        this.setState({
          selectedAutoSuggestIndex: selectIndexUp,
          lastArrowAction: "ArrowUp",
        });
        break;
      case "Enter":
      case "Tab":
        let indexToSelect = 0;
        if (
          this.state.selectedAutoSuggestIndex != 0 &&
          this.state.lastArrowAction == "ArrowUp"
        ) {
          indexToSelect = this.state.selectedAutoSuggestIndex;
        } else if (
          this.state.selectedAutoSuggestIndex != 0 &&
          this.state.lastArrowAction == "ArrowDown"
        ) {
          indexToSelect = this.state.selectedAutoSuggestIndex;
        }
        // const indexToSelect = this.state.selectedAutoSuggestIndex===0?0:this.state.lastArrowAction?"ArrowUp"?this.state.selectedAutoSuggestIndex+1:this.state.selectedAutoSuggestIndex-1:0;
        const selectedItem = this.state.autoSuggestCityData[indexToSelect - 1];
        this.setState({
          activityName: selectedItem.search_text,
          selectedAutoSuggestData: selectedItem,
          isError: false,
          isAutoSuggestVisible: false,
          selectedAutoSuggestIndex: indexToSelect,
          lastArrowAction: "",
        });
        break;

      default:
        console.log("default", action);
        break;
    }
  };

  scrollToMyRef = () => {
    this.searchBoxRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  onClickTraveller = () => {
    if (!this.state.openTraveler) {
      this.setState({ openTraveler: true });
    } else {
      this.setState({ openTraveler: false });
    }
  };

  handleStarCheck = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  ratingHandler = (e) => {
    console.log("rating selected array =-->>", this.state.ratingSelected);
    const { value, checked } = e.target;
    const { ratingSelected } = this.state;

    if (checked) {
      this.setState({
        ratingSelected: [...ratingSelected, value],
      });
    } else {
      this.setState({
        ratingSelected: ratingSelected.filter((e) => e !== value),
      });
    }
  };

  handleClickOutside = (e) => {
    if (
      this.advanceSearchWrapper.current &&
      !this.advanceSearchWrapper.current.contains(e.target)
    ) {
      this.setState({ advSearch: false });
    }
    if (
      this.guestDetailWrapper.current &&
      !this.guestDetailWrapper.current.contains(e.target)
    ) {
      this.setState({ openTraveler: false });
    }
  };

  onChangeVisibility = (bool) => {
    this.setState({
      isCalendarVisible: bool,
      isAutoSuggestVisible: false,
      isDateError: false,
    });
  };
  closeDestinationPopup = () => {
    this.setState({ destinationDropdown: false });
  };

  getSelectedPax = (pax) => {
    console.log("pax====>", pax);
  };

  onTravellerData(value) {
    this.setState({ travelers: value }, () => {
      console.log("travelers====>", this.state.travelers);
    });
  }

  countryClickHandler = (e) => {
    // this.setState({ pickuploc: e.value, isError[hotelName]: false });
    this.setState((prevState) => ({
      pickuploc: e.value,
      isError: false,
    }));
    this.setState({ SelectedCountry: e });
    this.setState({ countryCode: e.value });
    this.setState({ selectedCountryLocation: e.countryName });
    console.log("ddd", e);
  };
  countryChangeHandler = (e) => {
    this.setState({ countryCode: e.target.value });
    // this.setState({ pickuploc: e.target.value, isError[hotelName]: false });
    this.setState((prevState) => ({
      pickuploc: e.target.value,
      isError: false,
    }));
    this.setState({ SelectedCountry: { flag: "/images/user-active.png" } });
    this.setState({ countryCode: e.target.value });
    // for Hotel Namechange handler
    const countryFlag1 = this.state.countryList.filter((ele) =>
      ele.value.includes(e.target.value)
    );
    if (countryFlag1.length === 0) {
      this.setState({ selectedHotelAddress: e.target.value, isError: false });
      this.setState({ pickuploc: "" });
      this.setState({ selectedCountryLocation: "" });
    }
  };

  onButtonEnquiry() {
    if (!(this.state.pickuploc || this.state.selectedHotelAddress)) {
      this.setState({ isError: true });
    }
    if (this.state.checkInOutValue == "") {
      this.setState({ isDateError: true });
    }
    if (
      (this.state.pickuploc || this.state.selectedHotelAddress) &&
      this.state.checkInOutValue
    ) {
      this.createEnquiry();
    }
  }

  createEnquiry = () => {
    this.setState({ btnClicked: true }, () => {
      let data = {
        site_id: this.props?.side_id || "",
        service_type: "activity",
        service_data: {
          detail: {
            name: this.state.selectedHotelAddress || "",
            city: this.state.pickuploc || "",
            country: this.state.selectedCountryLocation || "",
            travel_date: format(
              new Date(this.state.checkInOutValue),
              "yyyy-MM-dd"
            ),
            no_of_adults: this.state.travelers.adults,
            no_of_childs: this.state.travelers.children,
            no_of_infants: this.state.travelers.infants,
          },
        },
      };

      offlineCreateEnquiry(data).then((res) => {
        this.setState({
          enquiry_id: res.enquiry_id,
          onLoadPopup: true,
          btnClicked: false,
        });
      });
    });
  };
  selectedTripId = (id) => {
    this.setState({ bookingTripId: id });    
  }

  render() {
    return (
      <>
        {this.props.isMobile ? (
          // mobile section starts
          <div
            className="container mx-auto xl:px-8"
            ref={this.searchBoxRef}
            onClick={(e) => {
              e.stopPropagation();
              if (this.state.isAutoSuggestVisible) {
                this.setState({
                  isAutoSuggestVisible: false,
                });
              }
              if (this.state.isCalendarVisible) {
                this.setState({
                  isCalendarVisible: false,
                });
              }
            }}
          >
            <div className={this.props.cssfile.activity_search_wid_container1}>
              <div className={this.props.cssfile.activity_search_wid_main}>
                <div id={this.props.cssfile.tab_submenu_content}>
                  {!this.props.isOffline && (
                    <div
                      className={
                        this.props.cssfile.landing_tab_submenu_new +
                        " " +
                        this.props.cssfile.sub_tab_new
                      }
                    >
                      <div className={this.props.cssfile.mobile_visible}>
                        <div
                          className={
                            this.props.cssfile.mobo_tab_header +
                            " " +
                            this.props.cssfile.flight_header_mobo
                          }
                        >
                          {this.props.isSrp ? (
                            <img
                              src="/images/blue-backarrow.svg"
                              alt=""
                              className={this.props.cssfile.arrow_image}
                              onClick={() => this.props.onClosePopup(false)}
                            />
                          ) : (
                            <img
                              src="/images/blue-backarrow.svg"
                              alt=""
                              className={this.props.cssfile.arrow_image}
                              onClick={() => this.props.onClosePopup(false)}
                            />
                          )}
                          <h3
                            className={this.props.cssfile.search_filter_header}
                          >
                            {" "}
                            {this.props.isSrp ? "Modify search" : "Activities"}
                          </h3>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className={this.props.cssfile.activity_way_title}>
                  {/* <h2>Activities</h2> */}
                </div>
                <div
                  className={`
                    ${this.props.cssfile.activity_search_details_container}
                    ${
                      this.props.offlineType == "Enquiry"
                        ? this.props.cssfile.offline_activity
                        : ""
                    }
                  `}
                >
                  <div
                    className={this.props.cssfile.activity_search_details_main}
                  >
                                     {this.props?.sessionData?.type == "B2E"&&!this.props.isSrp&&<TripTypeSelector
                                        bookingType={this.state.bookingType}
                                        selectedTripId={(value)=>{this.selectedTripId(value)}}
                                        styles={this.props.cssfile}
                                        bookingTypeId={this.state.bookingTripId}
                                      />}
                    <div
                      className={
                        this.props.offlineType == "Enquiry"
                          ? this.props.cssfile.activity_search_details_row +
                            " " +
                            this.props.cssfile
                              .activity_search_details_row_offline
                          : this.props.cssfile.activity_search_details_row
                      }
                    >
                      {this.props.offlineType != "Enquiry" && (
                        <div
                          className={
                            this.props.cssfile.activity_search_column +
                            " " +
                            this.props.cssfile.activity_search_name
                          }
                        >
                          <div
                            id="search-widget-main"
                            className={
                              this.props.cssfile.activity_search_wid_inputfield
                            }
                          >
                            <label>
                              {this.props.offlineType == "Enquiry"
                                ? "Select City/Destination"
                                : "Where to?"}
                            </label>
                            <div
                              className={
                                this.props.cssfile
                                  .activity_search_wid_inputfield_main
                              }

                              // onClick={this.scrollToMyRef}
                            >
                              <svg width="17" height="19">
                                <path
                                  fill-rule="evenodd"
                                  fill="#01445F"
                                  d="M9.33 18.152c-.39.042-.49.063-.589.063a.707.707 0 0 1-.292-.063C3.569 15.937.656 12.24.656 8.26.656 3.791 4.283.155 8.741.155c4.458 0 8.084 3.636 8.084 8.105 0 3.98-2.913 7.677-7.495 9.892zM8.741 1.574c-3.111 0-6.021 3-6.021 6.686 0 3.33 1.838 6.476 6.021 8.463 4.183-1.987 6.669-5.133 6.669-8.463 0-3.686-2.992-6.686-6.669-6.686zm0 10.17A3.483 3.483 0 0 1 5.267 8.26a3.483 3.483 0 0 1 3.474-3.483 3.483 3.483 0 0 1 0 6.967zm0-5.547a2.063 2.063 0 0 0 0 4.127 2.063 2.063 0 0 0 0-4.127z"
                                ></path>
                              </svg>
                              <input
                                type="text"
                                // readOnly
                                tabIndex={1}
                                placeholder={`Search for a place or activity`}
                                autoComplete={"off"}
                                id="myTextField"
                                className={
                                  this.props.cssfile.search_widget_input_new
                                }
                                value={
                                  // !cf.isValueEmpty(this.state.activityName) &&
                                  // !this.state.isAutoSuggestVisible
                                  //   ?
                                  this.state.activityName
                                  //   : ""
                                }
                                onChange={(event) => {
                                  event.stopPropagation();
                                  this.onChanegeSetActivityName(
                                    event.target.value
                                  );
                                }}
                                onClick={(e) => {
                                  // this.scrollToMyRef();
                                  e.stopPropagation();
                                  this.setState((prevState) => {
                                    return {
                                      ...prevState,
                                      destinationDropdown: true,
                                      isCalendarVisible: false,
                                      activityName: "",
                                      autoSuggestCityData: popularCities,
                                    };
                                  });
                                }}
                              />

                              {this.state.isError && (
                                <div className={this.props.cssfile.errordate}>
                                  {"Enter Destination"}
                                </div>
                              )}

                              {this.state.destinationDropdown && (
                                <>
                                  <div
                                    className={
                                      this.props.cssfile
                                        .activity_autocomplete_value
                                    }
                                    id="ACTIVITY-AUTO-SUGGEST-DATA-LIST"
                                  >
                                    <div
                                      class={
                                        this.props.cssfile
                                          .activity_suggestionLbl
                                      }
                                    >
                                      Suggestions
                                    </div>

                                    {!cf.isValueEmpty(
                                      this.state.autoSuggestCountryData
                                    ) &&
                                      this.state.autoSuggestCountryData.length >
                                        0 &&
                                      this.state.countryData.map(
                                        (element, index) => {
                                          return (
                                            <div
                                              id={"COUNTRY-" + index}
                                              key={element.search_text}
                                              className={
                                                this.props.cssfile
                                                  .activity_autocomplete_element
                                              }
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                this.setState({
                                                  activityName:
                                                    element.search_text,
                                                  isAutoSuggestVisible: false,
                                                  destinationDropdown: false,
                                                });
                                                this.onClickSetActivityName(
                                                  element
                                                );
                                              }}
                                            >
                                              <img src="images/location-01.svg" />
                                              <div>
                                                <div
                                                  className={
                                                    this.props.cssfile
                                                      .activity_autocomplete_name
                                                  }
                                                >
                                                  {element.search_text}
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    {!cf.isValueEmpty(
                                      this.state.autoSuggestCityData
                                    ) &&
                                    this.state.autoSuggestCityData.length >
                                      0 ? (
                                      this.state.autoSuggestCityData.map(
                                        (element, index) => {
                                          return (
                                            <div
                                              id={"ACTIVITY_CITY-" + index}
                                              key={`city-${element.search_text}`}
                                              className={
                                                this.props.cssfile
                                                  .activity_autocomplete_element
                                              }
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                this.setState({
                                                  activityName:
                                                    element.search_text,
                                                  isAutoSuggestVisible: false,
                                                  destinationDropdown: false,
                                                });
                                                this.onClickSetActivityName(
                                                  element
                                                );
                                              }}
                                            >
                                              {/* <img src="images/location-01.svg" /> */}
                                              <div
                                                className={
                                                  this.props.cssfile
                                                    .activity_autocompIcon
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="17"
                                                  height="22"
                                                >
                                                  <path
                                                    fill-rule="evenodd"
                                                    d="m14.769 13.53-6.19 8.098c-.061.06-.152.12-.242.12a.276.276 0 0 1-.242-.12l-6.19-8.098a8.116 8.116 0 0 1 0-9.82C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.173a8.119 8.119 0 0 1 0 9.82zm-.483-9.458a7.482 7.482 0 0 0-5.949-2.931c-2.355 0-4.53 1.058-5.949 2.931a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zM8.337 13.47c-2.657 0-4.832-2.176-4.832-4.835S5.68 3.8 8.337 3.8s4.831 2.176 4.831 4.835-2.174 4.835-4.831 4.835zm0-9.066a4.242 4.242 0 0 0-4.228 4.231 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.242 4.242 0 0 0-4.228-4.231z"
                                                  ></path>
                                                </svg>
                                              </div>
                                              <div>
                                                <div
                                                  className={
                                                    this.props.cssfile
                                                      .activity_autocomplete_name
                                                  }
                                                >
                                                  {element.search_text}
                                                </div>
                                                {/* <div className={this.props.cssfile.activity_autonwLabel}>United Arab Emirates</div> */}
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <div
                                        key={`noresults`}
                                        className={
                                          this.props.cssfile
                                            .activity_autocomplete_element
                                        }
                                      >
                                        {/* <img src="images/location-01.svg" /> */}
                                        {/* <span></span> */}
                                        <div
                                          className={
                                            this.props.cssfile.noresult_icon
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="17"
                                            height="22"
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              d="m14.769 13.53-6.19 8.098c-.061.06-.152.12-.242.12a.276.276 0 0 1-.242-.12l-6.19-8.098a8.116 8.116 0 0 1 0-9.82C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.173a8.119 8.119 0 0 1 0 9.82zm-.483-9.458a7.482 7.482 0 0 0-5.949-2.931c-2.355 0-4.53 1.058-5.949 2.931a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zM8.337 13.47c-2.657 0-4.832-2.176-4.832-4.835S5.68 3.8 8.337 3.8s4.831 2.176 4.831 4.835-2.174 4.835-4.831 4.835zm0-9.066a4.242 4.242 0 0 0-4.228 4.231 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.242 4.242 0 0 0-4.228-4.231z"
                                            ></path>
                                          </svg>
                                        </div>
                                        <div>
                                          <div
                                            className={
                                              this.props.cssfile
                                                .activity_autocomplete_noresultnw
                                            }
                                          >
                                            No Results Found
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {/* {JSON.stringify(this.props)} */}
                      {this.props.offlineType == "Enquiry" &&
                        this.props?.isSrp == false && (
                          <div
                            className={
                              this.props.cssfile.activity_offline_enqCOnt
                            }
                          >
                            <label>Select City/Destination</label>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="20"
                            >
                              <path
                                fill-rule="evenodd"
                                fill="#01445F"
                                d="M13.74 14.634c-2.441 2.48-3.93 4.946-4.04 5.046-1.397.06-2.544.06-3.312 0-.011-.1-2.229-2.566-4.003-5.046C1.33 12.746 0 10.549 0 8.594 0 4.33 3.463.868 7.729.868s7.729 3.462 7.729 7.726c0 1.955-1.033 4.152-1.718 6.04zM7.729 1.682A6.917 6.917 0 0 0 .813 8.594c0 1.806.985 3.823 2.647 5.567 1.31 2.408 3.464 4.296 3.464 4.296.461.403 1.806.403 1.61 0 0 0 2.155-1.888 3.878-4.296 1.248-1.744 2.233-3.761 2.233-5.567a6.917 6.917 0 0 0-6.916-6.912zm0 10.571c-2.021 0-3.049-1.64-3.049-3.66 0-2.019 1.028-3.659 3.049-3.659 2.02 0 3.661 1.64 3.661 3.659 0 2.02-1.641 3.66-3.661 3.66zm0-6.506c-1.572 0-2.848 1.483-2.848 2.846a2.848 2.848 0 0 0 5.695 0c0-1.363-1.275-2.846-2.847-2.846z"
                              ></path>
                            </svg>

                            <CountryDropdownComp
                              countryFlag={
                                this.state.countryList
                                  ? this.state.countryList
                                  : []
                              }
                              searchText={this.state.countryCode}
                              selectCountry={this.countryClickHandler}
                              selectedCountry={this.state.selectedCountry}
                              onChangeInputCountryCode={
                                this.countryChangeHandler
                              }
                              placeholder={"Select City"}
                              style={this.props.styles}
                              {...this.props.Countrystyles}
                              theme={"theme4"}
                            />
                            {this.state.isError && (
                              <div className={this.props.cssfile.errordate}>
                                {"Enter Destination"}
                              </div>
                            )}
                          </div>
                        )}
                      <div
                        className={`${this.props.cssfile.activity_search_column} ${this.props.cssfile.activity_search_date}`}
                      >
                        <div className={this.props.cssfile.flex_calwp}>
                          <MobileCalender
                            tabIndex={2}
                            label={
                              this.props.offlineType == "Enquiry"
                                ? "From Date"
                                : "When"
                            }
                            styles={this.props.calendarStyles}
                            value={
                              !cf.isValueEmpty(this.state.checkInOutValue)
                                ? this.state.checkInOutValue
                                : ""
                            }
                            placholder="Select Date"
                            onChangeDate={(dateVal) => {
                              this.onChangeCheckInOutValue(dateVal);
                            }}
                            iconImage={<img src="images/calendar-01.svg" />}
                            startDate={cf.getDateWithFormat(
                              new Date(),
                              this?.props?.dateFormat
                            )}
                            startDateLimit={cf.getDateWithFormat(
                              new Date(),
                              this?.props?.dateFormat
                            )}
                            dateFormat={this?.props?.dateFormat}
                            changeVisibility={(bool) => {
                              this.scrollToMyRef();
                              this.setState({
                                isCalendarVisible: bool,
                                isAutoSuggestVisible: false,
                                isDateError: false,
                              });
                            }}
                            isVisible={this.state.isCalendarVisible}
                            doubleSelection={false}
                          />
                        </div>
                        {this.state.isDateError && (
                          <div className={this.props.cssfile.errordate}>
                            {"Please select Date"}
                          </div>
                        )}
                      </div>

                      {this.props.offlineType == "Enquiry" ? (
                        <div className={this.props.cssfile.paxSelect_container}>
                          <PassengerCounter
                            travelers={this.state.travelers}
                            cssfile={this.props.cssfile}
                            getSelectedPax={this.getSelectedPax}
                            onTravellerData={this.onTravellerData.bind(this)}
                            maxPaxAllowed={this.state.maxPaxAllowed}
                          />
                        </div>
                      ) : null}

                      <div className={this.props.cssfile.activity_search_class}>
                        <button
                          tabIndex={3}
                          className={
                            this.props.cssfile.activity_search_widget_btn
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            this.props.offlineType == "Enquiry"
                              ? this.onButtonEnquiry()
                              : this.onClickSearchActivity();
                          }}
                          onFocus={(e) => {
                            e.stopPropagation();
                            this.onInputFocus("search");
                          }}
                        >
                          {this.props.offlineType == "Enquiry"
                            ? this.state.btnClicked
                              ? "Loading..."
                              : "Enquiry"
                            : "Search"}
                        </button>
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // mobile section ends

          // desktop section starts
          <div
            className={this.props.isSrp ? null : "container mx-auto xl:px-8 "}
          >
            <div className={this.props.isSrp ? "" : ""}>
              <div
                className="activity_searchpage"
                ref={this.searchBoxRef}
                onClick={(e) => {
                  e.stopPropagation();
                  if (this.state.isAutoSuggestVisible) {
                    this.setState({
                      isAutoSuggestVisible: false,
                    });
                  }
                  if (this.state.isCalendarVisible) {
                    this.setState({
                      isCalendarVisible: false,
                    });
                  }
                }}
              >
                <div
                  className={
                    this.props.isSrp
                      ? this.props.cssfile.srp_search_wid_container
                      : this.props.cssfile.activity_search_wid_container
                  }
                >
                  <div
                    className={
                      this.props.isSrp
                        ? "activity_search_wid_main container"
                        : "activity_search_wid_main"
                    }
                  >
                    <div className={this.props.cssfile.activity_way_title}>
                      {/* <h2>Activities</h2> */}
                    </div>
                    {this.props?.sessionData?.type == "B2E"&&!this.props.isSrp&&<TripTypeSelector
                                        bookingType={this.state.bookingType}
                                        selectedTripId={(value)=>{this.selectedTripId(value)}}
                                        styles={this.props.cssfile}
                                        bookingTypeId={this.state.bookingTripId}
                                      />}
                    {this.props?.sessionData?.type === "B2B" && false && (
                      <B2BWidgets
                        {...this.state}
                        styles={this.props.b2bStyles}
                        type={"activity"}
                        onClickTraveller={this.onClickTraveller}
                        onClickAdvSearch={this.onClickAdvSearch}
                        addGuestId={this.adGuestId}
                        removeGuestId={this.rmGuestId}
                        ratingHandler={this.ratingHandler}
                        handleStarCheck={this.handleStarCheck}
                        isOffline={this.props.isOffline}
                        listWrapper={this.advanceSearchWrapper}
                        guestWrapper={this.guestDetailWrapper}
                        errorMessage={"Select Traveler"}
                        isError={this.state.guestError}
                        theme={"theme4"}
                      />
                    )}
                    <div
                      className={
                        this.props.isSrp
                          ? this.props.cssfile.srp_search_details_container
                          : this.props.cssfile.activity_search_details_container
                      }
                    >
                      <div
                        className={
                          this.props.cssfile.activity_search_details_main
                        }
                      >
                        <div
                          className={
                            this.props.offlineType == "Enquiry"
                              ? this.props.cssfile.activity_search_details_row +
                                " " +
                                this.props.cssfile
                                  .activity_search_details_row_offline
                              : this.props.cssfile.activity_search_details_row
                          }
                        >
                          <div
                            className={
                              this.props.cssfile.activity_search_column +
                              " " +
                              this.props.cssfile.activity_search_name
                            }
                          >
                            {this.props.offlineType != "Enquiry" && (
                              <div
                                id="search-widget-main"
                                className={
                                  this.props.cssfile
                                    .activity_search_wid_inputfield
                                }
                              >
                                <label>
                                  {this.props.offlineType == "Enquiry"
                                    ? "Select City/Destination"
                                    : "Where to?"}
                                </label>
                                <div
                                  className={
                                    this.props.cssfile
                                      .activity_search_wid_inputfield_main
                                  }

                                  // onClick={this.scrollToMyRef}
                                >
                                  <input
                                    type="text"
                                    // readOnly
                                    tabIndex={1}
                                    placeholder={`Search for a place or activity`}
                                    autoComplete={"off"}
                                    id="myTextField"
                                    className={
                                      this.props.cssfile.search_widget_input_new
                                    }
                                    value={
                                      // !cf.isValueEmpty(this.state.activityName)
                                      //   ? this.state.activityName
                                      //   : ""
                                      this.state.activityName
                                    }
                                    onChange={(event) => {
                                      event.stopPropagation();
                                      this.onChanegeSetActivityName(
                                        event.target.value
                                      );
                                    }}
                                    onClick={(e) => {
                                      // this.scrollToMyRef();
                                      e.stopPropagation();
                                      this.onChanegeSetActivityName(
                                        e.target.value
                                      );
                                      this.setState((prevState) => {
                                        return {
                                          ...prevState,
                                          isAutoSuggestVisible: true,
                                          isCalendarVisible: false,
                                          activityName: "",
                                          autoSuggestCityData: popularCities,
                                        };
                                      });
                                    }}
                                    // onKeyDown={(e) => {
                                    //   e.stopPropagation();
                                    //   this.keyPress(e.key);
                                    // }}
                                  />
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="20"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      fill="#01445F"
                                      d="M13.74 14.634c-2.441 2.48-3.93 4.946-4.04 5.046-1.397.06-2.544.06-3.312 0-.011-.1-2.229-2.566-4.003-5.046C1.33 12.746 0 10.549 0 8.594 0 4.33 3.463.868 7.729.868s7.729 3.462 7.729 7.726c0 1.955-1.033 4.152-1.718 6.04zM7.729 1.682A6.917 6.917 0 0 0 .813 8.594c0 1.806.985 3.823 2.647 5.567 1.31 2.408 3.464 4.296 3.464 4.296.461.403 1.806.403 1.61 0 0 0 2.155-1.888 3.878-4.296 1.248-1.744 2.233-3.761 2.233-5.567a6.917 6.917 0 0 0-6.916-6.912zm0 10.571c-2.021 0-3.049-1.64-3.049-3.66 0-2.019 1.028-3.659 3.049-3.659 2.02 0 3.661 1.64 3.661 3.659 0 2.02-1.641 3.66-3.661 3.66zm0-6.506c-1.572 0-2.848 1.483-2.848 2.846a2.848 2.848 0 0 0 5.695 0c0-1.363-1.275-2.846-2.847-2.846z"
                                    />
                                  </svg>

                                  {this.state.isError && (
                                    <div
                                      className={this.props.cssfile.errordate}
                                    >
                                      {"Enter Destination"}
                                    </div>
                                  )}

                                  {this.state.isAutoSuggestVisible === true ? (
                                    <div
                                      className={
                                        this.props.cssfile
                                          .activity_autocompContainer
                                      }
                                    >
                                      <div
                                        className={
                                          this.props.cssfile
                                            .input_search_destination
                                        }
                                      ></div>
                                      <div
                                        className={
                                          this.props.cssfile
                                            .activity_autocompWrap
                                        }
                                      >
                                        <div
                                          className={
                                            this.props.cssfile
                                              .activity_autocomplete_value
                                          }
                                          id="ACTIVITY-AUTO-SUGGEST-DATA-LIST"
                                        >
                                          <div
                                            className={
                                              this.props.cssfile
                                                .activity_suggestionLbl
                                            }
                                          >
                                            Suggestions
                                          </div>

                                          {!cf.isValueEmpty(
                                            this.state.autoSuggestCountryData
                                          ) &&
                                            this.state.autoSuggestCountryData
                                              .length > 0 &&
                                            this.state.countryData.map(
                                              (element, index) => {
                                                return (
                                                  <div
                                                    id={index}
                                                    key={element.search_text}
                                                    className={
                                                      this.props.cssfile
                                                        .activity_autocomplete_element
                                                    }
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      this.setState({
                                                        activityName:
                                                          element.search_text,
                                                        isAutoSuggestVisible: false,
                                                        destinationDropdown: false,
                                                      });
                                                      this.onClickSetActivityName(
                                                        element
                                                      );
                                                    }}
                                                  >
                                                    <img src="images/location-01.svg" />
                                                    <div>
                                                      <div
                                                        className={
                                                          this.props.cssfile
                                                            .activity_autocomplete_name
                                                        }
                                                      >
                                                        {element.search_text}
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}

                                          {!cf.isValueEmpty(
                                            this.state.autoSuggestCityData
                                          ) &&
                                          this.state.autoSuggestCityData
                                            .length > 0 ? (
                                            this.state.autoSuggestCityData.map(
                                              (element, index) => {
                                                return (
                                                  <div
                                                    id={
                                                      "ACTIVITY_CITY-" + index
                                                    }
                                                    key={`city-${element.search_text}`}
                                                    className={
                                                      this.props.cssfile
                                                        .activity_autocomplete_element
                                                    }
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      this.setState({
                                                        activityName:
                                                          element.search_text,
                                                        isAutoSuggestVisible: false,
                                                        destinationDropdown: false,
                                                      });
                                                      this.onClickSetActivityName(
                                                        element
                                                      );
                                                    }}
                                                  >
                                                    {/* <img src="images/location-01.svg" /> */}
                                                    {/* <span></span> */}
                                                    <div
                                                      className={
                                                        this.props.cssfile
                                                          .activity_autocompIcon
                                                      }
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="17"
                                                        height="22"
                                                      >
                                                        <path
                                                          fill-rule="evenodd"
                                                          d="m14.769 13.53-6.19 8.098c-.061.06-.152.12-.242.12a.276.276 0 0 1-.242-.12l-6.19-8.098a8.116 8.116 0 0 1 0-9.82C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.173a8.119 8.119 0 0 1 0 9.82zm-.483-9.458a7.482 7.482 0 0 0-5.949-2.931c-2.355 0-4.53 1.058-5.949 2.931a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zM8.337 13.47c-2.657 0-4.832-2.176-4.832-4.835S5.68 3.8 8.337 3.8s4.831 2.176 4.831 4.835-2.174 4.835-4.831 4.835zm0-9.066a4.242 4.242 0 0 0-4.228 4.231 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.242 4.242 0 0 0-4.228-4.231z"
                                                        ></path>
                                                      </svg>
                                                    </div>
                                                    <div>
                                                      <div
                                                        className={
                                                          this.props.cssfile
                                                            .activity_autocomplete_name
                                                        }
                                                      >
                                                        {element.search_text}
                                                      </div>
                                                      {/* <div className={this.props.cssfile.activity_autonwLabel}>United Arab Emirates</div> */}
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )
                                          ) : (
                                            <div
                                              key={`noresults`}
                                              className={
                                                this.props.cssfile
                                                  .activity_autocomplete_noresult
                                              }
                                            >
                                              {/* <img src="images/location-01.svg" /> */}
                                              {/* <span></span> */}
                                              <div
                                                className={
                                                  this.props.cssfile
                                                    .noresult_icon
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="17"
                                                  height="22"
                                                >
                                                  <path
                                                    fill-rule="evenodd"
                                                    d="m14.769 13.53-6.19 8.098c-.061.06-.152.12-.242.12a.276.276 0 0 1-.242-.12l-6.19-8.098a8.116 8.116 0 0 1 0-9.82C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.173a8.119 8.119 0 0 1 0 9.82zm-.483-9.458a7.482 7.482 0 0 0-5.949-2.931c-2.355 0-4.53 1.058-5.949 2.931a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zM8.337 13.47c-2.657 0-4.832-2.176-4.832-4.835S5.68 3.8 8.337 3.8s4.831 2.176 4.831 4.835-2.174 4.835-4.831 4.835zm0-9.066a4.242 4.242 0 0 0-4.228 4.231 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.242 4.242 0 0 0-4.228-4.231z"
                                                  ></path>
                                                </svg>
                                              </div>
                                              <div>
                                                <div
                                                  className={
                                                    this.props.cssfile
                                                      .activity_autocomplete_noresultnw
                                                  }
                                                >
                                                  No Results Found
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            )}

                            {this.props.offlineType == "Enquiry" && (
                              <div
                                className={
                                  this.props.cssfile.activity_offline_enqCOnt
                                }
                              >
                                <label>Select City/Destination</label>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="20"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    fill="#01445F"
                                    d="M13.74 14.634c-2.441 2.48-3.93 4.946-4.04 5.046-1.397.06-2.544.06-3.312 0-.011-.1-2.229-2.566-4.003-5.046C1.33 12.746 0 10.549 0 8.594 0 4.33 3.463.868 7.729.868s7.729 3.462 7.729 7.726c0 1.955-1.033 4.152-1.718 6.04zM7.729 1.682A6.917 6.917 0 0 0 .813 8.594c0 1.806.985 3.823 2.647 5.567 1.31 2.408 3.464 4.296 3.464 4.296.461.403 1.806.403 1.61 0 0 0 2.155-1.888 3.878-4.296 1.248-1.744 2.233-3.761 2.233-5.567a6.917 6.917 0 0 0-6.916-6.912zm0 10.571c-2.021 0-3.049-1.64-3.049-3.66 0-2.019 1.028-3.659 3.049-3.659 2.02 0 3.661 1.64 3.661 3.659 0 2.02-1.641 3.66-3.661 3.66zm0-6.506c-1.572 0-2.848 1.483-2.848 2.846a2.848 2.848 0 0 0 5.695 0c0-1.363-1.275-2.846-2.847-2.846z"
                                  ></path>
                                </svg>
                                <CountryDropdownComp
                                  countryFlag={
                                    this.state.countryList
                                      ? this.state.countryList
                                      : []
                                  }
                                  searchText={this.state.countryCode}
                                  selectCountry={this.countryClickHandler}
                                  selectedCountry={this.state.selectedCountry}
                                  onChangeInputCountryCode={
                                    this.countryChangeHandler
                                  }
                                  placeholder={"Select City"}
                                  style={this.props.styles}
                                  {...this.props.Countrystyles}
                                  theme={"theme4"}
                                />
                                {this.state.isError && (
                                  <div className={this.props.cssfile.errordate}>
                                    {"Enter Destination"}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div
                            className={`${this.props.cssfile.activity_search_column} ${this.props.cssfile.activity_search_date}`}
                            tabIndex={2}
                            onFocus={(e) => {
                              e.stopPropagation();
                              this.setState({ isCalendarVisible: true });
                            }}
                          >
                            <DesktopCalender
                              label={
                                this.props.offlineType == "Enquiry"
                                  ? "From Date"
                                  : "When"
                              }
                              styles={this.props.calendarStyles}
                              value={this.state.checkInOutValue}
                              placholder="Select Date"
                              onChangeDate={(dateVal) => {
                                this.onChangeCheckInOutValue(dateVal);
                              }}
                              iconImage={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19"
                                  height="19"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    fill="#01445F"
                                    d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.85V3.148c0 .162-.49-.224-.892-.303a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.589.627.966V16.656c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627-.248-.25-.401-.303-.401-.968V3.148c0-.377.153-.718.401-.966.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.303v3.499zm16.922.94H.938v9.068c0 .117.049.224.702.303-.498.402-.391.892-.272.892h15.288c.118 0 .225-.49.304-.892.42-.077.9-.184.9-.303V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                  />
                                </svg>
                              }
                              startDate={cf.getDateWithFormat(
                                new Date(),
                                this?.props?.dateFormat
                              )}
                              startDateLimit={cf.getDateWithFormat(
                                new Date(),
                                this?.props?.dateFormat
                              )}
                              dateFormat={this?.props?.dateFormat}
                              changeVisibility={(bool) => {
                                // this.scrollToMyRef();
                                this.onChangeVisibility(bool);
                              }}
                              isVisible={this.state.isCalendarVisible}
                              doubleSelection={false}
                              type={"double"}
                            />
                            <span
                              className={this.props.cssfile.date_dropdown_icon}
                              onClick={() =>
                                this.setState({ isCalendarVisible: true })
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18px"
                                height="11px"
                                className={
                                  this.state.isCalendarVisible
                                    ? this.props.cssfile.arrow_rotate
                                    : ""
                                }
                              >
                                <path
                                  fill-rule="evenodd"
                                  fill="rgb(38, 106, 172)"
                                  d="M17.373,2.754 L9.979,10.211 C9.840,10.351 9.679,10.454 9.508,10.522 C9.003,10.729 8.403,10.626 7.994,10.213 L0.599,2.756 C0.054,2.206 0.054,1.315 0.599,0.765 C1.145,0.215 2.029,0.215 2.574,0.765 L8.985,7.230 L15.399,0.763 C15.944,0.213 16.828,0.213 17.373,0.763 C17.919,1.313 17.919,2.204 17.373,2.754 Z"
                                />
                              </svg>
                            </span>
                            {/* <span>
                        <small></small>
                      </span> */}
                            {this.state.isDateError && (
                              <div className={this.props.cssfile.errordate}>
                                {"Please select Date"}
                              </div>
                            )}
                          </div>

                          {this.props.offlineType == "Enquiry" ? (
                            <div
                              className={this.props.cssfile.paxSelect_container}
                            >
                              <PassengerCounter
                                travelers={this.state.travelers}
                                cssfile={this.props.cssfile}
                                getSelectedPax={this.getSelectedPax}
                                onTravellerData={this.onTravellerData.bind(
                                  this
                                )}
                                maxPaxAllowed={this.state.maxPaxAllowed}
                              />
                            </div>
                          ) : null}
                          {/* <div
                      className={`${this.props.cssfile.activity_search_details_row} ${this.props.cssfile.activity_nw}`}
                    > */}
                          <div
                            className={this.props.cssfile.activity_search_class}
                          >
                            <button
                              tabIndex={3}
                              className={
                                this.props.isSrp
                                  ? this.props.cssfile.srp_search_widget_btn
                                  : this.state.btnClicked
                                  ? `${this.props.cssfile.activity_search_widget_btn} `
                                  : this.props.cssfile
                                      .activity_search_widget_btn
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                this.props.offlineType == "Enquiry"
                                  ? this.onButtonEnquiry()
                                  : this.onClickSearchActivity();
                              }}
                              onFocus={(e) => {
                                e.stopPropagation();
                                this.onInputFocus("search");
                              }}
                            >
                              {/* <svg width="50px" height="50px" viewBox="0,0,256,256">
                          <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none">
                          <g transform="scale(5.12,5.12)"><path d="M21,3c-9.39844,0 -17,7.60156 -17,17c0,9.39844 7.60156,17 17,17c3.35547,0 6.46094,-0.98437 9.09375,-2.65625l12.28125,12.28125l4.25,-4.25l-12.125,-12.09375c2.17969,-2.85937 3.5,-6.40234 3.5,-10.28125c0,-9.39844 -7.60156,-17 -17,-17zM21,7c7.19922,0 13,5.80078 13,13c0,7.19922 -5.80078,13 -13,13c-7.19922,0 -13,-5.80078 -13,-13c0,-7.19922 5.80078,-13 13,-13z"></path>
                          </g></g>
                        </svg> */}
                              {this.props.offlineType == "Enquiry"
                                ? this.state.btnClicked
                                  ? "Loading..."
                                  : "Enquiry"
                                : "Search"}
                            </button>
                          </div>
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.onLoadPopup ? (
          <ModalPopupComponent
            isMobile={false}
            isPopup={true}
            onClosePopup={() => {
              this.setState({
                onLoadPopup: false,
              });
            }}
            modalCss={this.props.modalCss}
          >
            <div className={this.props.cssfile.enquiy_container}>
              <div className={this.props.cssfile.send_success}>
                <img src="theme4/tick.png" alt="send quote" />
                <div className={this.props.cssfile.send_lbl}>Send Enquiry</div>
              </div>
              <div className={this.props.cssfile.enquire_wrap}>
                <span className={this.props.cssfile.quote_lblTitle}>
                  Enquiry ID: {this.state?.enquiry_id}
                </span>
              </div>
              <span className={this.props.cssfile.quote_success}>
                Enquiry Request Successful
              </span>
              <div className={this.props.cssfile.btn_container}>
                <button
                  className={this.props.cssfile.ok_button}
                  onClick={() => {
                    this.setState({
                      onLoadPopup: false,
                    });
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </ModalPopupComponent>
        ) : null}
      </>
    );
  }
}